import UserHandler from "js/utilities/user-handler"
import UAParser from "ua-parser-js"

var uaparser = new UAParser();
var current = uaparser.getResult()
export default {

  // duplicate most of the code from fnapi-client - need
  // special case for amplitude - no apptoken or userToken in header
  fetch: function(method, endPoint, payload){
    var xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function() {
      if (xhttp.readyState == 4) {
        // console.log(xhttp.responseText);
      }
    };
    xhttp.open(method, endPoint+payload, true);
    xhttp.send();
    return;
  },

  //Sends a POST request to the API
  post: function(endPoint, payload={}){
    // console.log(JSON.stringify(payload));
    return this.fetch("POST", endPoint, JSON.stringify(payload));
  },


  send: function(event_type) {
    var data, now;
    now = Date.now();
    if (window.location.hostname.substring(0,3) === "dev") {
      event_type = "pr " + event_type
    }
    else {
      event_type = "qa " + event_type
    }
    // event_type = FN_MODE + " " + event_type;
    data = {
      user_id: (UserHandler.getUser() ? UserHandler.getUser().email : "annonymous"),
      // device_id: browser.name + " "  + browser.version,
      event_type: event_type,
      time: now || 0,
      // user_properties: {
      //   availableMemory: Ti.Platform.availableMemory,
      //   name: Ti.Platform.name
      // },
      app_version: ("ZoOmSDK"),
      platform: current.browser.name + " "  + current.browser.version,
      os_name: current.os.name,
      os_version: current.os.version,
      // device_brand: Ti.Platform.architecture || "none",
      // device_manufacturer: Ti.Platform.manufacturer || "none",
      // device_model: Ti.Platform.model || "none",
      language: window.navigator.userLanguage || window.navigator.language,
      // ip: Ti.Platform.address || "none"
    };
    if ((data.event_type == "qa amplitude-test") || (data.user_id != "zoomsdk@fnapi.com")) {
      this.post(AMPLITUDE,  data);
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/utilities/amplitude.jsx